import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamStateAggData } from './data-data';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractDataService implements AbstractDataService {

  abstract getTeamStateAggData(userIdOverride: string, orgIdOverride: string) : Observable <TeamStateAggData>;
}
